import axios from 'axios';
import {
  AI_PROMPT_BUILDER_CREATE_APP_BEGIN,
  AI_PROMPT_BUILDER_CREATE_APP_SUCCESS,
  AI_PROMPT_BUILDER_CREATE_APP_FAILURE,
  AI_PROMPT_BUILDER_CREATE_APP_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function createApp(args = {}) {
  return (dispatch) => {
    dispatch({
      type: AI_PROMPT_BUILDER_CREATE_APP_BEGIN,
    });

    const { projectId, version, createAppRequest } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/ai-prompt/create-app`,
        createAppRequest,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: AI_PROMPT_BUILDER_CREATE_APP_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: AI_PROMPT_BUILDER_CREATE_APP_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissCreateAppError() {
  return {
    type: AI_PROMPT_BUILDER_CREATE_APP_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case AI_PROMPT_BUILDER_CREATE_APP_BEGIN:
      return {
        ...state,
        createAppPending: true,
        createAppError: null,
      };

    case AI_PROMPT_BUILDER_CREATE_APP_SUCCESS:
      return {
        ...state,
        createAppPending: false,
        createAppError: null,
      };

    case AI_PROMPT_BUILDER_CREATE_APP_FAILURE:
      return {
        ...state,
        createAppPending: false,
        createAppError: action.data.error,
      };

    case AI_PROMPT_BUILDER_CREATE_APP_DISMISS_ERROR:
      return {
        ...state,
        createAppError: null,
      };

    default:
      return state;
  }
}
